import { type RefObject, useEffect, useRef } from 'react';

export const useInfiniteScroll = <Element extends HTMLElement>({
  enabled,
  onLoadMore,
}: {
  enabled: boolean;
  onLoadMore: () => void;
}): RefObject<Element | null> => {
  const sentinel = useRef<Element>(null);

  useEffect(() => {
    const target = sentinel.current;
    if (!enabled || target === null) {
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        onLoadMore();
      }
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [enabled, onLoadMore]);

  return sentinel;
};
